module.exports = __webpack_public_path__ + "static/media/v_interiors_gold_logo.274d1b46.svg";